// extracted by mini-css-extract-plugin
export default {"icon":"Location-module-bc3633ca17213cd2d6e3"};